import { useEffect, useState } from "react"
import moment from "moment-timezone"

import { checkPermission } from "shared/imports/permissionFunctions"

export const useSupportChat = () => {
    const [isEnabled, setIsEnabled] = useState(false)

    useEffect(() => {
        // based on app/static/frontend/imports/desktopHelperFunctions.js > chatIsAvailable
        /**
         * Check whether LiveChat is available
         */
        const chatIsAvailable = () => {
            // LEG-2714: Forethought AI is not working for Merck Organization. See ticket for more info!
            // COR-2300: removed Forethought access from WEX Inc.
            // LEG-3697, LEG-3699: Remove Forethought for Lincoln National Corporation, Legal Defense Fund
            const orgsWithoutForethoughtAccess = [1550, 2979, 5865, 5863]
            const hasPermission = checkPermission(DjangIO.app.models.PermissionType.live_chat)

            if (!orgsWithoutForethoughtAccess.includes(window.Userdata.organization_id) && hasPermission) {
                setIsEnabled(true)
                return
            }

            // Between 9am and 6pm EST
            const isBusinessHours =
                moment().isoWeekday() <= 5 && // 1 = Monday, 7 = Sunday
                moment().isBetween(
                    moment.tz("09:00:00", "HH:mm:ss", "America/New_York"),
                    moment.tz("18:00:00", "HH:mm:ss", "America/New_York"),
                    "second",
                )

            /* If the user has permission and it's business hours, check if agents are available.
             * Try a few times, because it isn't always ready on the first try.
             * This is a hack, but some users report the Chat option doesn't appear on initial load,
             * but pops in after the TopNav has re-rendered (navigated to another page).
             */
            if (hasPermission && isBusinessHours) {
                const checkAgentStatus = (attemptCount = 0) => {
                    try {
                        if (
                            window.zE &&
                            window.zE("webWidget:get", "chat:department", "Support")?.status === "online"
                        ) {
                            return setIsEnabled(true)
                        }
                    } catch {
                        return setIsEnabled(true)
                    }

                    if (attemptCount < 5) {
                        return setTimeout(() => checkAgentStatus(attemptCount + 1), 10 ** attemptCount)
                    }

                    return false
                }

                return checkAgentStatus()
            }
        }

        chatIsAvailable()
    }, [])

    return { isEnabled }
}
